import Cookies from 'js-cookie';
import { fetchJSON } from '../helpers/fetchHelper';

const consentBannerContainer = document.querySelector('[data-cookie-consent-overlay]');
const useConsentBanner = consentBannerContainer !== null;

/* Legacy banner code */
const bannerEl = document.querySelector('[data-cookiebanner]');
const acceptBtn = document.querySelector('[data-cookiebanner-btn]');
const policyUrl = '/cookiesbanner/cookiepolicyversion';
const activeClass = 'is-active';
const legacyCookieName = 'je-banner_cookie';

function setup () {
    bindEvents();
    checkToShowBanner();
}

function bindEvents () {

    if (acceptBtn) {
        acceptBtn.addEventListener('click', hideBanner);
    }

}

function checkToShowBanner () {
    if (bannerEl) {
        fetchJSON(policyUrl)
            .then(checkPolicyViewed)
            .catch(error => {
                throw error;
            });
    }
}

function checkPolicyViewed (policyNumber) {
    const usersCookieVersionViewed = Cookies.get(legacyCookieName);

    if (usersCookieVersionViewed !== policyNumber.toString()) {
        bannerEl.classList.add(activeClass);
        Cookies.set(legacyCookieName, policyNumber, { expires: 365 });
    }
}

function hideBanner (e) {
    e.preventDefault();
    bannerEl.classList.remove(activeClass);
}
/* End of legacy banner code */

/* Cookie Consent Banner code */
const dataLayer = window.dataLayer || [];

const cookieConsentConfig = {
    cookieExclusionList: [
        '_dc_gtm_',
        '_ga',
        '_gac_',
        '_gid',
        'AMP_TOKEN',
        'incap_ses_',
        'je-',
        'nlbi_',
        'optimizelyEndUserId',
        'optimizelyRedirectData',
        'optimizelyDomainTestCookie',
        'optimizelyOptOut',
        'ravelinDeviceId',
        'ravelinSessionUuid',
        'ravelinUuid',
        '__zlcmid',
        '__zlcprivacy'
    ],
    storageExclusionList: [
        'optimizely_data$$',
        'je-',
        'JE-'
    ],
    cookieExpiry: 90,
    consentCookieName: 'je-cookieConsent',
    legacyConsentCookieName: 'je-banner_cookie',
    legacyConsentCookieValue: '130315'
};

const cookieConsentCookieValue = Cookies.get(cookieConsentConfig.consentCookieName);
const shouldShowBanner = cookieConsentCookieValue !== 'full' && cookieConsentCookieValue !== 'necessary';

const checkIosSafari = function () {
    const cookieConsentCard = document.getElementsByClassName('c-cookieBanner-card');
    if (/(iPhone|iPad).*Safari/.test(navigator.userAgent)) {
        cookieConsentCard[0].classList.add('c-cookieBanner-ios');
    }
};

const setCookie = function (cookieName, cookieValue, cookieExpiresDays) {
    Cookies.set(cookieName, cookieValue, {
        path: '/',
        expires: cookieExpiresDays
    });
};

const isNotExcluded = function (name, excludedList) {
    var isMatch = true;
    for (let i = 0; i < excludedList.length; i++) {
        const regex = new RegExp(excludedList[i].replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g');
        if (regex.test(name) && isMatch) isMatch = false;
    }
    return isMatch;
};

const removeCookies = function () {
    var cookies = document.cookie.split('; ');
    for (let c = 0; c < cookies.length; c++) {
        const cookieName = cookies[c].split(';')[0].split('=')[0];
        if (isNotExcluded(cookieName, cookieConsentConfig.cookieExclusionList)) {
            const d = window.location.hostname.split('.');
            while (d.length > 0) {
                const cookieBase = `${encodeURIComponent(cookieName)}=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=${d.join('.')} ;path=`;
                const path = window.location.pathname.split('/');
                document.cookie = `${cookieBase}/`;
                while (path.length > 0) {
                    document.cookie = cookieBase + path.join('/');
                    path.pop();
                }
                d.shift();
            }
        }
    }
};

const removeStorage = function () {
    if (!localStorage) return;
    for (const i in localStorage) {
        if (localStorage.hasOwnProperty(i)) {
            if (isNotExcluded(i, cookieConsentConfig.storageExclusionList)) {
                localStorage.removeItem(i);
            }
        }
    }
};

const dataLayerPush = function (consentLevel) {
    dataLayer.push({ event: 'trackConsent', userData: { consent: consentLevel } });
};

const resendEvents = function () {
    var excludeEvents = ['gtm.js', 'gtm.click', 'gtm.linkClick', 'gtm.triggerGroup', 'trackConsent', 'showConsent'];
    for (let i = 0; i < dataLayer.length; i++) {
        if (dataLayer[i].event && !excludeEvents.includes(dataLayer[i].event)) {
            dataLayer[i].eventResent = dataLayer[i].event;
            dataLayer[i]['gtm.uniqueEventId'] = Math.floor(100000 + Math.random() * 900000);
            dataLayer.push(dataLayer[i]);
        }
        if (dataLayer[i].event && dataLayer[i].event === 'trackConsent' && (dataLayer[i].userData.consent === 'full' || dataLayer[i].userData.consent === 'necessary')) {
            dataLayer.push({ eventResent: false });
            break;
        }
    }
};

const cookieConsentHideBanner = function () {
    var cookieConsentBanner = document.querySelector('[data-cookie-consent-overlay]');
    cookieConsentBanner.classList.add('is-hidden');
};

const cookieConsentAcceptAction = function () {
    setCookie(cookieConsentConfig.consentCookieName, 'full', cookieConsentConfig.cookieExpiry);
    setCookie(cookieConsentConfig.legacyConsentCookieName, cookieConsentConfig.legacyConsentCookieValue, cookieConsentConfig.cookieExpiry);
    dataLayerPush('full');
    resendEvents();
    cookieConsentHideBanner();
};

const cookieConsentNonAcceptAction = function () {
    removeCookies();
    removeStorage();
    setCookie(cookieConsentConfig.consentCookieName, 'necessary', cookieConsentConfig.cookieExpiry);
    setCookie(cookieConsentConfig.legacyConsentCookieName, cookieConsentConfig.legacyConsentCookieValue, cookieConsentConfig.cookieExpiry);
    dataLayerPush('necessary');
    resendEvents();
    cookieConsentHideBanner();
};

const addEventHandlers = function () {
    var cookieConsentBannerAcceptButton = document.querySelector('[data-button-accept]');
    var cookieConsentBannerNonAcceptButton = document.querySelector('[data-button-nonaccept]');
    cookieConsentBannerAcceptButton.addEventListener('click', cookieConsentAcceptAction, false);
    cookieConsentBannerNonAcceptButton.addEventListener('click', cookieConsentNonAcceptAction, false);
};

const showBanner = function () {
    const cookieConsentBanner = document.querySelector('[data-cookie-consent-overlay]');
    cookieConsentBanner.classList.remove('is-hidden');
    addEventHandlers();
    dataLayerPush('shown');
};
/* End of Cookie Consent Banner code */

/* Instantiate banner logic */
if (useConsentBanner) {
    if (shouldShowBanner) {
        checkIosSafari();
        showBanner();
        document.querySelector('[data-consent-title]').focus();
    }
} else {
    setup();
}
